/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Expandable Styling
   ========================================================================== */
.o-expandable {
  position: relative;
}
.o-expandable__header {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  padding: 0.625em 0.9375em;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.o-expandable__header:focus {
  outline: 1px dotted var(--black);
  outline-offset: 2px;
}
.o-expandable__header .o-expandable__cue-close,
.o-expandable__header .o-expandable__cue-open {
  display: none;
}
.o-expandable__header[aria-expanded=false] .o-expandable__cue-open {
  display: block;
}
.o-expandable__header[aria-expanded=true] .o-expandable__cue-close {
  display: block;
}
.o-expandable button.o-expandable__header {
  width: 100%;
  text-align: left;
}
.o-expandable__label {
  flex-grow: 1;
  margin-bottom: 0;
  color: var(--black);
  font-weight: 500;
}
.o-expandable__icon, .o-expandable__label {
  font-size: 1.125em;
}
@media only all and (max-width: 37.5em) {
  .o-expandable__icon, .o-expandable__label {
    font-size: 1em;
  }
}
.o-expandable__cues {
  align-self: center;
  color: var(--pacific);
  font-size: 1em;
  line-height: 1.375;
}
.o-expandable__content {
  padding: 0.9375em;
  padding-top: 0;
}
.o-expandable__content::before {
  content: "";
  display: block;
  border-top: 1px solid var(--gray-40);
  padding-top: 0.9375em;
}
.o-expandable__content::after {
  padding-bottom: 0.9375em;
  width: 100%;
}
.o-expandable--padded .o-expandable__header {
  padding: 1.5625em 0.9375em;
}
.o-expandable--padded .o-expandable__icon, .o-expandable--padded .o-expandable__label {
  font-size: 1.625em;
}
@media only all and (max-width: 37.5em) {
  .o-expandable--padded .o-expandable__icon, .o-expandable--padded .o-expandable__label {
    font-size: 1.375em;
  }
}
.o-expandable--background {
  background: var(--gray-5);
}
.o-expandable--border {
  border: 1px solid var(--gray-40);
}
.o-expandable-group .o-expandable {
  border-bottom: 1px solid var(--gray-40);
}
.o-expandable-group .o-expandable:first-child {
  border-top: 1px solid var(--gray-40);
}
@media print {
  .o-expandable__header[aria-expanded=true] .o-expandable__cue-close, .o-expandable__header[aria-expanded=false] .o-expandable__cue-open {
    display: none;
  }
  .o-expandable__content[aria-expanded=false] {
    display: block;
    max-height: 99999px !important;
  }
}
.o-expandable .print__header[aria-expanded=true] .o-expandable .print__cue-close, .o-expandable .print__header[aria-expanded=false] .o-expandable .print__cue-open {
  display: none;
}
.o-expandable .print__content[aria-expanded=false] {
  display: block;
  max-height: 99999px !important;
}

html[lang=ar] .o-expandable__header {
  text-align: right;
}
html[lang=ar] .o-expandable__cues {
  text-align: left;
}